// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/images/sidebarBG.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Google Font Link */
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins" , sans-serif;
}


.sidebar{
  position: absolute;
  top: 0;
  bottom: 0;
  left: -78px;
  min-height: 100vh;
  width: 78px;
  /* background: #404040; */
    padding: 6px 14px;
  z-index: 99;
  transition: all 0.5s ease;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;

}
.sidebar.open{
  width: 250px;
  left: -250px;
}
.sidebar .logo-details{
  height: 50px;
  display: flex;
  align-items: center;
  position: relative;

  transition: all 0.3s ease;
}
.sidebar .logo-details .icon{
  opacity: 0;
  transition: all 0.5s ease;
}
.sidebar .logo-details .logo_name{
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  opacity: 0;
  transition: all 0.5s ease;
}
.sidebar.open .logo-details .icon,
.sidebar.open .logo-details .logo_name{
  opacity: 1;
}
.sidebar .logo-details #btn{
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  font-size: 22px;
  transition: all 0.4s ease;
  font-size: 23px;
  text-align: center;
  cursor: pointer;
  transition: all 0.5s ease;
}
.sidebar.open .logo-details #btn{
  text-align: right;
}
.sidebar i{
  color: #fff;
  height: 60px;
  min-width: 50px;
  font-size: 28px;
  text-align: center;
  line-height: 60px;
}
.sidebar .nav-list{
  margin-top: 20px;
}
.sidebar li{
  position: relative;
  margin: 8px 0;
  list-style: none;
}
.sidebar li.activeSidebar{
  box-shadow: 0px 4px 20px 0px #00000026;
  background: #FFFFFF;
border-radius: 14px;
}
.sidebar li.activeSidebar .links_name{
  color: #000;
  font-family: 'Poppins',sans-serif;
font-size: 14px;
font-weight: 400;
line-height: 16px;
text-align: left;

}
.sidebar li .tooltip{
  position: absolute;
  top: -20px;
  left: calc(100% + 15px);
  z-index: 3;
  background: #404040;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 400;
  opacity: 0;
  white-space: nowrap;
  pointer-events: none;
  transition: 0s;
  color: white;
}
.sidebar li:hover .tooltip{
  opacity: 1;
  pointer-events: auto;
  transition: all 0.4s ease;
  top: 50%;
  transform: translateY(-50%);
}
.sidebar.open li .tooltip{
  display: none;
}


.sidebar li a{
  display: flex;
  height: 100%;
  width: 100%;
  border-radius: 12px;
  align-items: center;
  text-decoration: none;
  transition: all 0.4s ease;
  margin-bottom: 15px;
  position: relative;
  padding: 1em 1em;
}

.open .sb-icon-wrapper{
  position: static;
  transform: none;
}



.sidebar li a:hover{
  background: rgba(233, 156, 156, 0.1);
}

.sidebar li a .links_name{
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: 0.4s;
}
.sidebar.open li a .links_name{
  opacity: 1;
  pointer-events: auto;
}
.sidebar li a:hover .links_name,
.sidebar li a:hover i{
  transition: all 0.5s ease;
}
.sidebar li i{
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  border-radius: 12px;
}


.sidebar li.profile .name,
.sidebar li.profile .job{
  font-size: 15px;
  font-weight: 400;
  color: #fff;
  white-space: nowrap;
}
.sidebar li.profile .job{
  font-size: 12px;
}

.sidebar.open ~ .home-section{
  left: 250px;
  width: calc(100% - 250px);
}
.home-section .text{
  display: inline-block;
  color: #11101d;
  font-size: 25px;
  font-weight: 500;
  margin: 18px
}
@media (max-width: 420px) {
  .sidebar li .tooltip{
    display: none;
  }
}

.sb-icon-wrapper{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}


.sb-icon-wrapper img{

  height: 25px;
}


.nav-list{
    padding-left: 0;
}

.links_name{
  margin-left: 10px;
}

.logo-icon img{
  width: 100% !important;
}

.open .logo-icon{
  width: 50px;
  transition: none;
  transform: translateY(100%);
  margin-top: -54px;
}

.sidebar li a.call-link,
.sidebar li a.call-link:hover {
  background-color: #E11F1C88;
  border-radius: 7px;
}


@media screen and (max-width: 1200px) {
  .sidebar li a{
    margin-bottom: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/sidebar/sidebar.css"],"names":[],"mappings":"AAAA,qBAAqB;AAErB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,mCAAmC;AACrC;;;AAGA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,yBAAyB;IACvB,iBAAiB;EACnB,WAAW;EACX,yBAAyB;EACzB,yDAA0D;EAC1D,4BAA4B;;AAE9B;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;;EAElB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,yBAAyB;AAC3B;AACA;;EAEE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,mBAAmB;AACrB,mBAAmB;AACnB;AACA;EACE,WAAW;EACX,iCAAiC;AACnC,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,gBAAgB;;AAEhB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,YAAY;AACd;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,yBAAyB;EACzB,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;;;AAIA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;;AAGA;;EAEE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;;AAGA;;EAEE,YAAY;AACd;;;AAGA;IACI,eAAe;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;EAC3B,kBAAkB;AACpB;;;AAGA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Google Font Link */\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700&display=swap');\n*{\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Poppins\" , sans-serif;\n}\n\n\n.sidebar{\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: -78px;\n  min-height: 100vh;\n  width: 78px;\n  /* background: #404040; */\n    padding: 6px 14px;\n  z-index: 99;\n  transition: all 0.5s ease;\n  background-image: url(/public/assets/images/sidebarBG.png);\n  background-repeat: no-repeat;\n\n}\n.sidebar.open{\n  width: 250px;\n  left: -250px;\n}\n.sidebar .logo-details{\n  height: 50px;\n  display: flex;\n  align-items: center;\n  position: relative;\n\n  transition: all 0.3s ease;\n}\n.sidebar .logo-details .icon{\n  opacity: 0;\n  transition: all 0.5s ease;\n}\n.sidebar .logo-details .logo_name{\n  color: #fff;\n  font-size: 20px;\n  font-weight: 600;\n  opacity: 0;\n  transition: all 0.5s ease;\n}\n.sidebar.open .logo-details .icon,\n.sidebar.open .logo-details .logo_name{\n  opacity: 1;\n}\n.sidebar .logo-details #btn{\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  font-size: 22px;\n  transition: all 0.4s ease;\n  font-size: 23px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.5s ease;\n}\n.sidebar.open .logo-details #btn{\n  text-align: right;\n}\n.sidebar i{\n  color: #fff;\n  height: 60px;\n  min-width: 50px;\n  font-size: 28px;\n  text-align: center;\n  line-height: 60px;\n}\n.sidebar .nav-list{\n  margin-top: 20px;\n}\n.sidebar li{\n  position: relative;\n  margin: 8px 0;\n  list-style: none;\n}\n.sidebar li.activeSidebar{\n  box-shadow: 0px 4px 20px 0px #00000026;\n  background: #FFFFFF;\nborder-radius: 14px;\n}\n.sidebar li.activeSidebar .links_name{\n  color: #000;\n  font-family: 'Poppins',sans-serif;\nfont-size: 14px;\nfont-weight: 400;\nline-height: 16px;\ntext-align: left;\n\n}\n.sidebar li .tooltip{\n  position: absolute;\n  top: -20px;\n  left: calc(100% + 15px);\n  z-index: 3;\n  background: #404040;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 15px;\n  font-weight: 400;\n  opacity: 0;\n  white-space: nowrap;\n  pointer-events: none;\n  transition: 0s;\n  color: white;\n}\n.sidebar li:hover .tooltip{\n  opacity: 1;\n  pointer-events: auto;\n  transition: all 0.4s ease;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.sidebar.open li .tooltip{\n  display: none;\n}\n\n\n.sidebar li a{\n  display: flex;\n  height: 100%;\n  width: 100%;\n  border-radius: 12px;\n  align-items: center;\n  text-decoration: none;\n  transition: all 0.4s ease;\n  margin-bottom: 15px;\n  position: relative;\n  padding: 1em 1em;\n}\n\n.open .sb-icon-wrapper{\n  position: static;\n  transform: none;\n}\n\n\n\n.sidebar li a:hover{\n  background: rgba(233, 156, 156, 0.1);\n}\n\n.sidebar li a .links_name{\n  color: #fff;\n  font-size: 14px;\n  font-weight: 400;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: 0.4s;\n}\n.sidebar.open li a .links_name{\n  opacity: 1;\n  pointer-events: auto;\n}\n.sidebar li a:hover .links_name,\n.sidebar li a:hover i{\n  transition: all 0.5s ease;\n}\n.sidebar li i{\n  height: 50px;\n  line-height: 50px;\n  font-size: 18px;\n  border-radius: 12px;\n}\n\n\n.sidebar li.profile .name,\n.sidebar li.profile .job{\n  font-size: 15px;\n  font-weight: 400;\n  color: #fff;\n  white-space: nowrap;\n}\n.sidebar li.profile .job{\n  font-size: 12px;\n}\n\n.sidebar.open ~ .home-section{\n  left: 250px;\n  width: calc(100% - 250px);\n}\n.home-section .text{\n  display: inline-block;\n  color: #11101d;\n  font-size: 25px;\n  font-weight: 500;\n  margin: 18px\n}\n@media (max-width: 420px) {\n  .sidebar li .tooltip{\n    display: none;\n  }\n}\n\n.sb-icon-wrapper{\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n\n.sb-icon-wrapper img{\n\n  height: 25px;\n}\n\n\n.nav-list{\n    padding-left: 0;\n}\n\n.links_name{\n  margin-left: 10px;\n}\n\n.logo-icon img{\n  width: 100% !important;\n}\n\n.open .logo-icon{\n  width: 50px;\n  transition: none;\n  transform: translateY(100%);\n  margin-top: -54px;\n}\n\n.sidebar li a.call-link,\n.sidebar li a.call-link:hover {\n  background-color: #E11F1C88;\n  border-radius: 7px;\n}\n\n\n@media screen and (max-width: 1200px) {\n  .sidebar li a{\n    margin-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
